import React from 'react';
import {
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';

import iosStore from 'assets/images/apple.png';
import googleStore from 'assets/images/google.png';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';

const iOSUrl = 'https://apps.apple.com/app/fgraph/id1572609905';
const androidUrl =
  'https://play.google.com/store/apps/details?id=io.fgraph.shinobiwallet';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#282828',
    height: 400,
    color: '#fff',
    padding: '80px 0',
    marginBottom: 100,
    [theme.breakpoints.down('sm')]: {
      height: 300,
    },
  },
  btnApps: {
    // display: 'flex',
    // marginTop: 20,
  },

  btnApple: {
    cursor: 'pointer',
    borderRadius: '10px',
    width: '256px',
    height: '81px',
    backgroundImage: `url(${iosStore})`,
    marginRight: '20px',
    marginLeft: '20px',
    outline: 'none',
    border: '1px solid #a6a6a6',
    [theme.breakpoints.down('xs')]: {
      width: '125px',
      height: '45px',
      backgroundSize: '125px 45px',
    },
  },
  btnAndroid: {
    cursor: 'pointer',
    borderRadius: '10px',
    width: '256px',
    height: '81px',
    backgroundImage: `url(${googleStore})`,
    marginRight: '20px',
    marginLeft: '20px',
    outline: 'none',
    border: '1px solid #a6a6a6',
    [theme.breakpoints.down('xs')]: {
      width: '125px',
      height: '45px',
      backgroundSize: '125px 45px',
    },
  },
}));

export default function DownloadApp() {
  const classes = useStyles();
  const history = useHistory();
  const {t} = useTranslation();

  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        <Grid style={{textAlign: 'center'}}>
          <Typography variant="h3" style={{marginBottom: 40}}>
            Download here
          </Typography>

          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="row">
            <Grid xs={6} md={6} align={'center'} item>
              <Button
                className={classes.btnApple}
                onClick={() => window.open(iOSUrl, '_blank')}></Button>
            </Grid>
            <Grid xs={6} md={6} item align={'center'}>
              <Button
                className={classes.btnAndroid}
                onClick={() => window.open(androidUrl, '_blank')}></Button>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
